import { getPendingUploads } from './getPendingUploads'
import { saveImageToIndexedDB } from './saveImageToIndexedDB'
import { savePendingUploads } from './savePendingUploads'

export interface FileImage {
  indexedDBImageId?: number
  id?: string
  file?: File
  latitude?: number
  longitude?: number
  created_at?: Date
  user: {
    id?: string,
    name?: string,
    avatar_url?: string,
  }
}

export interface PendingUpload {
  pendingUploadId: string
  reportId: string
  imagesList: FileImage[]
  imagesToRemove?: string[]
  created_at: Date
}

export async function addPendingUpload(pending: PendingUpload) {
  const updatedImagesList = await Promise.all(
    pending.imagesList.map(async (img) => {
      if (img.file) {
        const id = await saveImageToIndexedDB(img.file)
        return { ...img, indexedDBImageId: id, file: undefined }
      }
      return img
    }),
  )

  const pendingUpload: PendingUpload = {
    pendingUploadId: pending.pendingUploadId,
    reportId: pending.reportId,
    imagesList: updatedImagesList,
    imagesToRemove: pending.imagesToRemove,
    created_at: pending.created_at,
  }

  const uploads = getPendingUploads()
  uploads.push(pendingUpload)
  savePendingUploads(uploads)
}
